<template>
    <div class="activity">
        <item-header>招标项目</item-header>
        <div class="container">
            <!-- 招标公告 -->
            <section class="public">
                <div class="box">
                    <span class="title">招标公告</span>
                    <span class="line"></span>
                    <span class="more">
                        <img src="../../assets/images/item_refresh.png" alt="">换一批
                    </span>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="itemList">
                    <li class="itemLis">
                        <span class="left">日期</span>
                        <span class="right">招标项目</span>
                    </li>
                    <li class="itemLis">
                        <a href="http://www.ccgp-shandong.gov.cn/sdgp2017/site/read.jsp?id=201179888" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">山东省济南市章丘区人民代表大会常务委员会办公室预算监督联网系统采购项目采购需求公示</span>
                        </a>
                </li>
                    <li class="itemLis">
                        <a href="http://www.ccgp-shandong.gov.cn/sdgp2017/site/readneed.jsp?id=200057362" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">山东省公安厅交通警察总队南综合技术楼空调改造工程采购需求公示</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="http://www.ccgp-shandong.gov.cn/sdgp2017/site/read.jsp?id=201257925" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">济南市市中区人民政府党家街道办事处综合整治工程采购需求公示</span >
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="http://www.ccgp-shandong.gov.cn/sdgp2017/site/readneed.jsp?id=200057525" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">济南新旧动能转换先行区管理委员会综合执法部城乡环卫一体化垃圾桶采购采购需求公示</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="http://www.ccgp-shandong.gov.cn/sdgp2017/site/read.jsp?colcode=0301&id=201260458" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">山东省公安厅社会动态感知分布式节点试点应用服务项目公开招标公告</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="https://www.sdbidding.org.cn/bulletins/tender/2327133" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">济南市市中区人民政府党家街道办事处辖区内秸秆禁烧巡查项目</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="https://www.sdbidding.org.cn/bulletins/tender/2327125" target="_blank">
                            <span class="left">2019-10-13 </span>
                            <span class="right">济南市历城区王舍人街道西沙河二村小清河桥粉刷及防洪墙、自来水厂项目竞争性磋商公告</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="https://www.sdbidding.org.cn/bulletins/tender/2327109" target="_blank">
                            <span class="left">2019-10-12 </span>
                            <span class="right">山东省交通运输厅安全管理服务项目竞争性磋商公告</span>
                        </a>
                    </li>
                </ul>
            </section>
            <!-- 企业需求 -->
            <section class="public">
                <div class="box">
                    <span class="title">企业需求</span>
                    <span class="line"></span>
                    <span class="more">
                        <img src="../../assets/images/item_refresh.png" alt="">换一批
                    </span>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="itemList">
                    <li class="itemLis">
                        <span class="left">日期</span>
                        <span class="right">招标项目</span>
                    </li>
                    <li class="itemLis">
                        <a href="http://www.ccgp-shandong.gov.cn/sdgp2017/site/readneed.jsp?id=200057369" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">山东建筑大学财务一体化系统数据库、服务器等采购采购需求公示</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="http://www.ccgp-shandong.gov.cn/sdgp2017/site/readneed.jsp?id=200057368" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">山东财经大学教学业绩管理系统项目采购需求公示</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="http://www.ccgp-shandong.gov.cn/sdgp2017/site/readneed.jsp?id=20669" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">山东法官培训学院游泳馆网架维修改造项目采购需求公示</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="https://www.sdbidding.org.cn/bulletins/tender/2327159" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">济南热电有限公司金鸡岭热电分公司2019—2020年采暖季灰渣等固体废物处置项目竞争性谈判公告</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="https://www.sdbidding.org.cn/bulletins/tender/2327157" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">济南国际机场航站楼保洁业务外包项目招标公告</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="https://www.sdbidding.org.cn/bulletins/tender/2327153" target="_blank">
                            <span class="left">2019-10-14 </span>
                            <span class="right">济南东泰热力有限公司隔压站东线改造项目电气专业所需电缆采购招标公告</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="https://www.sdbidding.org.cn/bulletins/tender/2327106" target="_blank">
                            <span class="left">2019-10-12 </span>
                            <span class="right">山东太古飞机工程有限公司职业装 采购项目</span>
                        </a>
                    </li>
                    <li class="itemLis">
                        <a href="https://www.sdbidding.org.cn/bulletins/tender/2327099" target="_blank">
                            <span class="left">2019-10-12 </span>
                            <span class="right">交通银行股份有限公司山东省分行 营业部香江支行装修改造项目招标公告</span>
                        </a>
                    </li>
                </ul>
            </section>
        </div>
    </div>
</template>

<script>
import itemHeader from '../../components/Header';
export default {
    name: 'activity',
    components: {
        itemHeader
    },
    data() {
        return {
            
        }
    },
}
</script>

<style scoped>
.activity{
    background: #F2F3F7;
    min-height: 100vh;
}
.container{
    height: calc(100vh - 1rem);
    overflow: auto;
}
/* 招标公告 */
.public{
    margin-top: .2rem;
    padding: 0 .3rem;
    background: #fff;
}
.public .box{
    position: relative;
    height: .88rem;
    display: flex;
}
.public .box .title{
    font-weight: bold;
    font-size: .28rem;
    color: #D60000;
    margin-top: .3rem;
}
.public .box .line{
    width: 5.6rem;
    height: 0.02rem;
    background: #D60000;
    margin-top: .56rem;
    margin-left: auto;
}
.public .box .more{
    position: absolute;
    right: .14rem;
    color: #666;
    top: 50%;
    transform: translateY(-70%);
    padding: .1rem;
    display: flex;
    align-items: center
}
.public .box .more img{
    margin-right: .1rem;
}
.public .box .bd{
    position: absolute;
    right: 0;
    top: .44rem;
}
.public .itemLis a{
    display: flex;
    font-size: .24rem;
    justify-content: space-between;
    line-height: .8rem;
}
.public .itemList .itemLis:first-child{
    font-weight: bold;
    font-size: .36rem;
    text-align: center;
}
.public .itemList .itemLis:first-child .right{
    text-align-last: left;
}
.public .itemLis .left{
    width: 1.4rem;
}
.public .itemLis .right{
    width: 5rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
</style>